import React, { useCallback } from 'react';
import { color, image } from '@/theme';
import { PrimaryButton } from '@/components/button';
import { InputBasic, InputDate } from '@/components/input';
import { RegularText } from '@/components/text';
import { Image } from '@/components/shared';
import { GoogleRecaptcha } from '@/components/item';
import { LoadingSpinner } from '@/components/loading';
import { ButtonWrapper, InputRows, ButtonContent } from '../inquiry/inquryStyles';

const EventRequestDetails = ({ control, setStep, setValue, errors, isPending }) => {
  const goToPrev = useCallback(() => {
    setStep(1);
  }, [setStep]);

  return (
    <>
      <InputBasic
        control={control}
        name="event_name"
        label="lang-event-name"
        placeholder="lang-placeholder-event"
        required
        maxLength={50}
      />

      <InputBasic
        type="number"
        control={control}
        name="attendees"
        label="lang-attendees-event"
        placeholder="lang-placeholder-attendees-event"
        maxLength={50}
      />

      <InputBasic
        type="number"
        control={control}
        name="rooms"
        label="lang-rooms"
        placeholder="lang-placeholder-rooms"
        maxLength={20}
      />

      <InputRows>
        <InputDate control={control} name="arrival_date" label="lang-arrival" errors={errors} />

        <InputDate control={control} name="departure_date" label="lang-departure" errors={errors} />
      </InputRows>

      <InputBasic
        control={control}
        name="comments"
        label="lang-requirements"
        multiline
        rows={10}
        placeholder="lang-placeholder-requirements"
        maxLength={500}
      />

      <div style={{ padding: '2rem 0' }} />

      <GoogleRecaptcha setValue={setValue} errors={errors} />

      <ButtonWrapper>
        {isPending ? (
          <LoadingSpinner />
        ) : (
          <>
            <PrimaryButton type="button" onClick={goToPrev}>
              <ButtonContent>
                <Image src={image.arrowLeft.default} width="1.8rem" height="1.4rem" />

                <RegularText id="lang-prev" color={color.base_white} />
              </ButtonContent>
            </PrimaryButton>

            <PrimaryButton type="submit" width="92%">
              <ButtonContent>
                <RegularText id="lang-inquiry-submit" color={color.base_white} />

                <Image src={image.arrowRight.default} width="1.8rem" height="1.4rem" />
              </ButtonContent>
            </PrimaryButton>
          </>
        )}
      </ButtonWrapper>
    </>
  );
};

export default EventRequestDetails;
